/**
 * Created by René Simon <rene.simon@dr-huchler-und-partner.de> on 03.10.19.
 * Copyright © Dr. Huchler und Partner 2017
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field, propTypes, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {Card, CardActions} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';
import {translate} from 'admin-on-rest';
import LinkButton from '../../mui/buttons/link-button';
import {requestPasswordResetAction} from '../../redux/password-forgotten/actions';
import {validEmailAddress} from '../../forms/form-utils/field-validators';

const mailValidator = validEmailAddress(true);

const styles = {
  card: {
    minWidth: 300,
  },
  form: {
    padding: '0 1em 1em 1em',
  },
  input: {
    display: 'flex',
  },
};

const renderInput = ({
  meta: {touched, error} = {},
  input: {...inputProps},
  ...props
}) => (
  <TextField
    errorText={touched && error}
    {...inputProps}
    {...props}
    fullWidth
  />
);

renderInput.propTypes = {
  meta: PropTypes.object.isRequired,
};

class PasswordForgotten extends Component {
  submit = ({mailAddress}) => {
    const {
      requestReset,
      location: {
        state: {
          referrer,
        } = {},
      },
    } = this.props;
    requestReset({
      mailAddress,
      targetAdmin: !!referrer,
      notifications: 'ellis.forms.passwordForgotten.actions.requestPasswordReset',
    });
  }

  render() {
    const {handleSubmit, isLoading, translate} = this.props;
    return (
      <Card style={styles.card}>
        <form onSubmit={handleSubmit(this.submit)}>
          <div style={styles.form}>
            <div style={styles.input}>
              <Field
                name="mailAddress"
                component={renderInput}
                floatingLabelText={translate(
                  'ellis.forms.passwordForgotten.mailAddress',
                )}
                disabled={isLoading}
              />
            </div>
          </div>
          <CardActions>
            <RaisedButton
              type="submit"
              primary
              disabled={isLoading}
              icon={
                isLoading && (
                  <CircularProgress
                    size={25}
                    thickness={2}
                  />
                )
              }
              label={translate('ellis.forms.passwordForgotten.submit')}
              fullWidth
            />
          </CardActions>
        </form>
        <LinkButton
          primary
          disabled={isLoading}
          label="ellis.forms.passwordForgotten.back"
          route="/login"
          fullWidth
        />
      </Card>
    );
  }
}

PasswordForgotten.propTypes = {
  ...propTypes,
  translate: PropTypes.func.isRequired,
  requestReset: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({isLoading: state.admin.loading > 0});

const enhance = compose(
  translate,
  reduxForm({
    form: 'passwordForgotten',
    validate: (values, props) => {
      const errors = {};
      const {translate} = props;
      const {mailAddress} = values || {};
      if (!mailAddress) {
        errors.mailAddress = translate('aor.validation.required');
      } else {
        const mailError = mailValidator(mailAddress, values, props);
        if (mailError) {
          errors.mailAddress = mailError;
        }
      }
      return errors;
    },
  }),
  connect(mapStateToProps, {requestReset: requestPasswordResetAction}),
);

export default enhance(PasswordForgotten);
